import Maybe from 'true-myth/maybe';
import Result from 'true-myth/result';
import { fromResult } from 'true-myth/toolbelt';

import { competenciesSchema } from '../job-profile/job-profile-schema';
import { positionDetailsResponseSchema } from '../position-management/position-details';

import type { ValidatingHttpFetcherWithBaseUrl } from '../../../shared/source/validating-http-fetcher';
import type { LoaderFunction } from 'react-router';

export const createPositionsPageLoader = (
    validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl,
): LoaderFunction => {
    return async (loaderArguments) => {
        const positionId = Maybe.of(loaderArguments.params['id']);
        const mode = Maybe.of(loaderArguments.params['mode']);

        if (positionId.isNothing) {
            return Result.err(new Error('No id path parameter present'));
        }

        const [position, competencies] = await Promise.all([
            validatingCobrainerApiFetcher.get(positionDetailsResponseSchema, {
                pathname: `/positions/${positionId.value}`,
            }),
            validatingCobrainerApiFetcher.get(competenciesSchema, {
                pathname: '/skills/competencies',
            }),
        ]);

        const isInEditMode = mode.equals(Maybe.of('edit'));

        return Result.ok({
            competencies: fromResult(competencies),
            isInEditMode,
            position: fromResult(position),
        });
    };
};
